import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch { setSent(true); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Recuperar acesso"
      subtitle="Enviaremos um link seguro para redefinir sua senha."
      footer={<Link to="/login" className="flex items-center gap-1 text-sm text-primary mt-2" data-testid="voltar-login"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>}
    >
      {sent ? (
        <div className="rounded-md border border-primary/40 bg-primary/10 p-4 text-sm flex gap-3" data-testid="forgot-sent">
          <MailCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
          <p>Se este e-mail estiver cadastrado, você receberá as instruções para redefinir sua senha. Verifique também a caixa de spam.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label>E-mail cadastrado</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
          </div>
          <Button type="submit" className="w-full h-12 text-base font-bold" disabled={loading} data-testid="forgot-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar link de redefinição"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
